import { getCurrentAge } from "../../functions";
export const tokenSelector = ({ userReducer }) => ({
    token: userReducer.token,
});
export const isAdvisorSelector = ({ userReducer }) => userReducer.userData?.userType === "advisor";
export const currentClientSelector = ({ userReducer }) => userReducer.advisor.clients[userReducer.advisor.selectedClient];
export const isLinkedSelector = ({ userReducer, }) => {
    if (userReducer.userData?.userType === "advisor") {
        return userReducer.advisor?.clients[userReducer.advisor?.selectedClient]
            ?.isLinked;
    }
    else {
        return userReducer.userData?.isLinked;
    }
};
export const currentAgeSelector = ({ userReducer: { userData }, }) => getCurrentAge(userData?.dob || "1991-01-01");
export const currentUserDataSelector = (state) => {
    const isAdvisor = state.userReducer.userData?.userType === "advisor";
    return isAdvisor ? currentClientSelector(state) : state.userReducer.userData;
};
